<template>
    <div name="introduction" class="introduction" id="introduction">
        <div class="cont-introdu cont-introduc01">
            <div class="intro-text text0">
                <strong class="title">기다림 없이 <br><span class="text-primary">바로예약</span></strong>
                <span class="sub-title">진료 가능한 내 주변 병원을 찾고<br/>바로솔닥으로 간편하게 예약해요</span>
            </div>
            <div class="intro-image image0">
                <img src="../../assets/renew_pc/img_app_map.png" alt="바로솔닥 어플 주변병원 찾기"/>
            </div>
        </div>

        <div class="cont-introdu cont-introduc02">
            <div class="intro-text text1">
                <strong class="title">기다림 없이 <br><span class="text-primary">바로진료</span></strong>
                <span class="sub-title">예약한 시간에 맞춰 방문하면<br>대기 없이 진료를 볼 수 있어요</span>
            </div>
            <div class="intro-image image1">
                <img src="../../assets/renew_pc/img_app_timetable.png" alt="바로솔닥 어플 진료예약"/>
            </div>
        </div>
        
        <div class="cont-introdu cont-introduc03">
            <div class="intro-text text2">
                <strong class="title">기다림 없이 <br><span class="text-primary">바로결제</span></strong>
                <span class="sub-title">진료 후 수납을 위한 대기 없이<br/>앱에서 간편하게 결제할 수 있어요</span>
            </div>
            <div class="intro-image image2">
                <img src="../../assets/renew_pc/img_app_pay.png" alt="바로솔닥 어플 간편 결제"/>
            </div>
        </div>

        <div class="cont-introdu cont-introduc04">
            <div class="intro-text text3">
                <strong class="title">기다림 없이 <br><span class="text-primary">바로발급</span></strong>
                <span class="sub-title">서류는 앱에서 언제든지 확인하고<br>다운로드 받을 수 있어요</span>
            </div>
            <div class="intro-image image3">
                <img src="../../assets/renew_pc/img_app_doc.png" alt="바로솔닥 어플 필요서류"/>
            </div>
        </div>

		<span class="intro-dot"><span class="sr-only">1</span></span>
    </div>
</template>

<script>
export default {
    name: 'introduction',
    mounted: function()
    {
        $(window).scroll(function () {
            var height = $(document).scrollTop();
            var elementHeight = window.innerHeight ;
            // console.log(height);

            if(height < elementHeight* 2)
            {
                $('.image0').css('display', `none`);
                $('.image1').css('display', `none`);
                $('.image2').css('display', `none`);
                $('.image3').css('display', `none`);
                $('.text0').css('display', `none`);
                $('.text1').css('display', `none`);
                $('.text2').css('display', `none`);
                $('.text3').css('display', `none`);
                $('.intro-dot').css('opacity', `0`);
                $('.introduction .btn-section-mouse').css('opacity', `0`);
            }
            else if(height >= elementHeight* 2 && height < elementHeight* 3)
            {
                 //min max 알고리즘
                // let opacity = (height - 1700) / (2300 - 1700)
                $('.image0').css('display', `inline-block`);
                $('.image1').css('display', `none`);
                $('.image2').css('display', `none`);
                $('.image3').css('display', `none`);

                $('.text0').css('display', `flex`);
                $('.text1').css('display', `none`);
                $('.text2').css('display', `none`);
                $('.text3').css('display', `none`);
				$('.intro-dot').addClass('dot01');
                $('.intro-dot').removeClass('dot02');
                $('.intro-dot').removeClass('dot03');
                $('.intro-dot').removeClass('dot04');
				$('.intro-dot').css('opacity', `1`);
                $('.btn-section-mouse').css('opacity', `1`);
            }
            else if(height >= elementHeight* 3 && height < elementHeight* 3.5)
            {
                $('.image0').css('display', `inline-block`);
                $('.image1').css('display', `none`);
                $('.image2').css('display', `none`);
                $('.image3').css('display', `none`);

                $('.text0').css('display', `flex`);
                $('.text1').css('display', `none`);
                $('.text2').css('display', `none`);
                $('.text3').css('display', `none`);
				$('.intro-dot').addClass('dot01');
                $('.intro-dot').removeClass('dot02');
                $('.intro-dot').removeClass('dot03');
                $('.intro-dot').removeClass('dot04');
                $('.introduction .btn-section-mouse').css('opacity', `1`);
            }
            else if(height >= elementHeight* 3.5 && height < elementHeight* 4)
            {
				$('.image0').css('display', `none`);
                $('.image1').css('display', `none`);
                $('.image2').css('display', `none`);
                $('.image3').css('display', `none`);

                $('.text0').css('display', `none`);
                $('.text1').css('display', `none`);
                $('.text2').css('display', `none`);
                $('.text3').css('display', `none`);
				$('.intro-dot').addClass('dot01');
				$('.intro-dot span').html('1');
                $('.intro-dot').removeClass('dot02');
                $('.intro-dot').removeClass('dot03');
                $('.intro-dot').removeClass('dot04');
                $('.introduction .btn-section-mouse').css('opacity', `1`);
            }
            else if(height >= elementHeight* 4 && height < elementHeight* 5)
            {
                
                $('.image0').css('display', `none`);
                $('.image1').css('display', `inline-block`);
                $('.image2').css('display', `none`);
                $('.image3').css('display', `none`);
                
                $('.text0').css('display', `none`);
                $('.text1').css('display', `flex`);
                $('.text2').css('display', `none`);
                $('.text3').css('display', `none`);
				$('.intro-dot').addClass('dot02');
				$('.intro-dot span').html('2');
                $('.intro-dot').removeClass('dot01');
                $('.intro-dot').removeClass('dot03');
                $('.intro-dot').removeClass('dot04');
                $('.introduction .btn-section-mouse').css('opacity', `1`);
            }
            else if(height >= elementHeight* 5 && height < elementHeight* 5.5)
            {
                let opacity = 1;
                $('.image0').css('display', `none`);
                $('.image1').css('display', `inline-block`);
                $('.image2').css('display', `none`);
                $('.image3').css('display', `none`);

                $('.text0').css('display', `none`);
                $('.text1').css('display', `flex`);
                $('.text2').css('display', `none`);
                $('.text3').css('display', `none`);
                $('.intro-dot').removeClass('dot01');
                $('.intro-dot').removeClass('dot03');
                $('.intro-dot').removeClass('dot04');
                $('.introduction .btn-section-mouse').css('opacity', `1`);
            }
            else if(height >= elementHeight* 5.5 && height < elementHeight* 6)
            {
                //min max 알고리즘
                $('.image0').css('display', `none`);
                $('.image1').css('display', `none`);
                $('.image2').css('display', `none`);
                $('.image3').css('display', `none`);

                $('.text0').css('display', `none`);
                $('.text1').css('display', `none`);
                $('.text2').css('display', `none`);
                $('.text3').css('display', `none`);
				$('.intro-dot').addClass('dot02');
                $('.intro-dot').removeClass('dot01');
                $('.intro-dot').removeClass('dot03');
                $('.intro-dot').removeClass('dot04');
				$('.intro-dot span').html('2');
                $('.introduction .btn-section-mouse').css('opacity', `1`);
            }
            else if(height >= elementHeight* 6 && height < elementHeight* 7)
            {
                $('.image0').css('display', `none`);
                $('.image1').css('display', `none`);
                $('.image2').css('display', `inline-block`);
                $('.image3').css('display', `none`);
            
                $('.text0').css('display', `none`);
                $('.text1').css('display', `none`);
                $('.text2').css('display', `flex`);
                $('.text3').css('display', `none`);
				$('.intro-dot').addClass('dot03');
				$('.intro-dot span').html('3');
                $('.intro-dot').removeClass('dot01');
                $('.intro-dot').removeClass('dot02');
                $('.intro-dot').removeClass('dot04');
                $('.introduction .btn-section-mouse').css('opacity', `1`);
            }
            else if(height >= elementHeight* 7 && height < elementHeight* 7.5)
            {
                $('.image0').css('display', `none`);
                $('.image1').css('display', `none`);
                $('.image2').css('display', `inline-block`);
                $('.image3').css('display', `none`);

                $('.text0').css('display', `none`);
                $('.text1').css('display', `none`);
                $('.text2').css('display', `flex`);
                $('.text3').css('display', `none`);
				$('.intro-dot').addClass('dot03');
				$('.intro-dot span').html('3');
                $('.intro-dot').removeClass('dot01');
                $('.intro-dot').removeClass('dot02');
                $('.intro-dot').removeClass('dot04');
                $('.introduction .btn-section-mouse').css('opacity', `1`);
            }
            else if(height >= elementHeight* 7.5 && height < elementHeight* 8)
            {
                $('.image0').css('display', `none`);
                $('.image1').css('display', `none`);
                $('.image2').css('display', `none`);
                $('.image3').css('display', `none`);

                $('.text0').css('display', `none`);
                $('.text1').css('display', `none`);
                $('.text2').css('display', `none`);
                $('.text3').css('display', `none`);
                $('.introduction .btn-section-mouse').css('opacity', `1`);
            }
            else if(height >= elementHeight* 8 && height < elementHeight* 8.5)
			{
                $('.image0').css('display', `none`);
                $('.image1').css('display', `none`);
                $('.image2').css('display', `none`);
                $('.image3').css('display', `inline-block`);

                $('.text0').css('display', `none`);
                $('.text1').css('display', `none`);
                $('.text2').css('display', `none`);
                $('.text3').css('display', `flex`);
				$('.intro-dot').addClass('dot04');
				$('.intro-dot span').html('4');
                $('.intro-dot').removeClass('dot01');
                $('.intro-dot').removeClass('dot02');
                $('.intro-dot').removeClass('dot03');
				$('.intro-dot').css('opacity', `1`);
                $('.introduction .btn-section-mouse').css('opacity', `1`);
            }
            else if(height >= elementHeight* 8.5 && height < elementHeight* 9)
            {     
                $('.image0').css('display', `none`);
                $('.image1').css('display', `none`);
                $('.image2').css('display', `none`);
                $('.image3').css('display', `inline-block`);

                $('.text0').css('display', `none`);
                $('.text1').css('display', `none`);
                $('.text2').css('display', `none`);
                $('.text3').css('display', `flex`);
				$('.intro-dot').addClass('dot04');
                $('.intro-dot').removeClass('dot01');
                $('.intro-dot').removeClass('dot02');
                $('.intro-dot').removeClass('dot03');
                $('.intro-dot').css('opacity', `1`);
                $('.introduction .btn-section-mouse').css('opacity', `1`);
            }
            else
            {
                $('.image0').css('display', `none`);
                $('.image1').css('display', `none`);
                $('.image2').css('display', `none`);
                $('.image3').css('display', `none`);

                $('.text0').css('display', `none`);
                $('.text1').css('display', `none`);
                $('.text2').css('display', `none`);
                $('.text3').css('display', `none`);
                $('.intro-dot').removeClass('dot01');
                $('.intro-dot').removeClass('dot02');
                $('.intro-dot').removeClass('dot03');
				$('.intro-dot').removeClass('dot04');
                $('.intro-dot').css('opacity', `0`);
                $('.introduction .btn-section-mouse').css('opacity', `0`);
            }
        });    
    }
}
</script>

<style scoped>
    .introduction {
        position: relative;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: flex-start;
        min-width: 1200px;
        min-height: 4600px;
        height: 800vh;
        background: #fff;
        z-index: -2;
    }

    .cont-introdu{
        height: 100vh;
        width: 100%;
    }
    .title{
		flex-direction: column;
        font-weight: 600;
        font-size: 44px;
        line-height: 56px;
        color: #1A1A1A;
        animation: fadeInUp1 1s;
    }
    .sub-title{
        margin-top: 30px;
        font-weight: 400;
        font-size: 18px;
        line-height: 28px;
        color: #666;
        animation: fadeInUp2 1.5s;
    }

    .intro-image{
        position: fixed;
        top: 50%;
        left: 50%;
        display: none;
		width: 267px;
        margin-left: 43px;
        transform: translate(0, -50%);
        z-index: 0;      
        animation: fadeInUp 1s;
    }
    .intro-text{ 
        position: fixed;
        top: 50%;
        right: 50%;
        display: none;
        justify-content: center;
        flex-direction: column;
        align-items: flex-start;
		width: 333px;
        height: 552px;
		padding-bottom: 90px;
        transform: translate(0, -50%);
        z-index: 0;
    }

	.intro-dot{
		position: fixed;
		top: 50%;
		left: calc(50% + 342px);
		width: 10px;
		height: 64px;
		opacity: 0;
		transform: translate(0, -55%);
		animation: fadeInUp 1s;
	}
	.dot01{
		background: url(../../assets/renew_pc/bg_dot01.png);
	}
	.dot02{
		background: url(../../assets/renew_pc/bg_dot02.png);
	}
	.dot03{
		background: url(../../assets/renew_pc/bg_dot03.png);
	}
	.dot04{
		background: url(../../assets/renew_pc/bg_dot04.png);
	}
	
    /* .mouse{
        position: fixed;
        bottom: 23px;
        z-index: 2;
        opacity: 0;
        left: 50%;
        transform: translate(-50%);
    } */

    .btn-section-mouse{
        position: fixed;
        left: 50%;
        bottom: 25px;
        transform: translate(-50%);
        display: flex;
        flex-direction: column;
        width: 24px;
        height: 62px;
        margin: 0;
        padding: 0;
        background: none;
        border: none;
        z-index: 20;
    }
    .section-mouse{
        position: relative;
        display: block;
        width: 24px;
        height: 38px;
        height: auto;
    }
    .mouse-arrow{
        /* position: absolute;
        top: 0;
        left: 0; */
        display: block;
        width: 24px;
        height: 24px;
        transform-origin: 0px 0px;
        transform: translate(0, 0);
        animation: scroll-down 900ms ease-in-out infinite;
    }

    @keyframes scroll-down {
        0% {
        transform: translate(0, 0px);
        }
        30% {
        transform: translate(0, -5px);
        }       
        45% {
        transform: translate(0, 0px);
        }
        100% {
        transform: translate(0, 0px);
        }
    }

    @keyframes fadeInUp {
        0% {
            opacity: 0;
            transform: translate3d(0, 100%, 0);
        }
        100% {
            opacity: 1;
            transform: translate3d(0, -50%, 0);
        }
    }
    @keyframes fadeInUp1 {
        0% {
            opacity: 0;
            transform: translate3d(0, 100%, 0);
        }
        to {
            opacity: 1;
            transform: translate3d(0, 0%, 0);
        }
    }
    @keyframes fadeInUp2 {
        0% {
            opacity: 0;
            transform: translate3d(0, 130%, 0);
        }
        to {
            opacity: 1;
            transform: translate3d(0, 0%, 0);
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/pc_main/Introduction.vue